export * from './button-view.component';
export * from './custom-editor.component';
export * from './button-download.component';
export * from './button-download-check-table.component';
export * from './button-download-review/button-download-review.component';
export * from './button-view-form-dynamic.component';
export * from './buttons-accion-dynamic-forms-table.component';
export * from './date-refactory/range-refactory-table-dynamic.component';
export * from './buttons-associate-document.component';
export * from './button-delete.component';
export * from './date-refactory/calendar-refactory-table-dynamic.component';
export * from './date-refactory/dateTimer-refactory-table-dynamic.component';
export * from './date-refactory/rangeDate-refactory-table-dynamic.component';
export * from './date-refactory/rangeTimer-refactory-table-dynamic.component';
export * from './date-refactory/timer-refactory-table-dynamic.component';
export * from './coordinates-dynamic-forms.component';
export * from './buttons-actions-table.component';
export * from './check-table.component';
export * from './radio-buttons-check-list/radio-buttons-check-list.component';
export * from './status-tramite.component';
export * from './date-string.component';
export * from './info-radication-doc.component';
export * from './dynamic-column.component';
export * from './name-user-assignment.component';
export * from './button-download-delete.component';
export * from './row-selection-checkbox.component';
export * from './input-table/input-table.component';
export * from './thousands-separator-number-format.component';
export * from './label-ngSelect-dynamic-table.component';



// WEBPACK FOOTER //
// ./src/app/shared/component-table/index.ts